import axios from "axios";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import {
  IAIContentRequest,
  IAIContentResponseDto,
  IAITranslateRequest,
  IAITranslateResponseDto
} from "../interfaces/endpoints/IAIContent";

export const generateAIContent = async (
  data: IAIContentRequest
): Promise<IAxiosResponse<IAIContentResponseDto>> => {
  return axios.post<IAIContentResponseDto>("/AIContent/generate", data);
};

// Translating into ten languages is one slow model round trip, and the project sets no
// axios.defaults.timeout — without an explicit one a stalled call would hang the button forever.
const TRANSLATE_TIMEOUT_MS = 90000;

export const translateAIContent = async (
  data: IAITranslateRequest
): Promise<IAxiosResponse<IAITranslateResponseDto>> => {
  return axios.post<IAITranslateResponseDto>("/AIContent/translate", data, {
    timeout: TRANSLATE_TIMEOUT_MS
  });
};
